let modal = document.querySelector('#photo-modal');
let morePhotos = document.querySelector('#more-photos');
let activeModal = false;

if (modal && morePhotos) {
  morePhotos.querySelectorAll('.photo').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      toggleModal(true);

      setActive(thumb.getAttribute('data-thumbnail'));
    });
  });

  modal.querySelectorAll('.thumbnail').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      setActive(thumb.getAttribute('data-thumbnail'));
    });
  });

  modal.querySelector('.close').addEventListener('click', () => {
    toggleModal(false);
  });
}

function toggleModal (active) {
  if (active) {
    modal.classList.add('active');
  } else {
    modal.classList.remove('active');
  }

  document.querySelector('body').classList.toggle('freeze');
}

function setActive (slideNum) {
  modal.querySelector('#main').querySelector('.active').classList.remove('active');
  modal.querySelector('#main').querySelector(`.slide[data-main-slide="${slideNum}"]`).classList.add('active');
}